import React from "react";
import { Brain, Zap, Lock, Globe, Heart, Wand2 } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "Deep Memory",
    body: "Every AI character remembers your name, your story arc, your preferences and the details that make your chat feel personal. Conversations continue instead of starting from zero.",
  },
  {
    icon: Zap,
    title: "Instant Replies",
    body: "Character AI chat should feel alive. Sub-second replies keep the story moving with no awkward pauses, no waiting and no broken immersion.",
  },
  {
    icon: Wand2,
    title: "Cinematic Personalities",
    body: "Choose cozy crushes, fantasy queens, anime girls, rebels, detectives, villains, romantic companions or original AI characters with their own tone, mood and voice.",
  },
  {
    icon: Heart,
    title: "Built for Roleplay",
    body: "From slow-burn romance to fantasy adventures, mystery plots, emotional drama and chaotic comedy, every AI character can follow your story and stay in character.",
  },
  {
    icon: Lock,
    title: "Private by Default",
    body: "Your AI character conversations are made for private storytelling. Chat, roleplay and build personal storylines without feeling watched or interrupted.",
  },
  {
    icon: Globe,
    title: "Speaks Your Language",
    body: "Chat with AI characters in 30+ languages. Switch mid-conversation and your character keeps up with your tone, context and story.",
  },
];

const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="bg-white py-24 sm:py-32 border-t-2 border-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12">
        <div className="max-w-3xl">
          <span className="text-xs sm:text-sm font-bold tracking-[0.25em] uppercase font-body text-neutral-500">
            Why Character AI Chat
          </span>
          <h2
            data-testid="features-title"
            className="font-display mt-4 text-4xl sm:text-6xl font-black tracking-tighter uppercase leading-[0.95]"
          >
            The Fastest, Smartest <br />
            <span className="text-[#FF2D55]">Character AI Chat</span> on the
            Internet
          </h2>
          <p className="mt-6 font-body text-lg text-neutral-700 max-w-2xl leading-relaxed">
            Built from the ground up for immersive roleplay, emotional
            conversations and story-driven AI chat. Every character is
            designed with personality depth, memory and fast response time so
            your conversation feels like you are actually talking to someone.
          </p>
        </div>

        <ul className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <li
                key={f.title}
                data-testid={`feature-card-${i}`}
                className="bento-card border-2 border-neutral-200 bg-white p-7 sm:p-8 rounded-2xl"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-black text-white">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-display mt-6 text-2xl font-black tracking-tight">
                  {f.title}
                </h3>
                <p className="font-body mt-3 text-neutral-700 leading-relaxed">
                  {f.body}
                </p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Features;
